/// <reference types="vite/client" />

/**
 * Build-time env readers. Vite inlines these at build time via `import.meta.env`.
 * Anything we read here must be prefixed with VITE_.
 */

export const BOT_USERNAME = (import.meta.env.VITE_BOT_USERNAME ?? "").trim();
